import type { ActivityTypeResponse } from 'api/__GENERATED';
import { MISSING_VALUE } from 'config/app';

// Maps a single ActivityType DTO from the generated API client onto the
// normalized `Data.ActivityType` shape. `activityTypeCode` is still nullable
// in the DTO, so fall back to MISSING_VALUE to satisfy the non-null domain.
function toActivityType(dto: ActivityTypeResponse) {
  const { id, name, description, activityTypeCode, activityIds } = dto;

  const activityType: Data.ActivityType = {
    id,
    name,
    description: description ?? '',
    code: activityTypeCode ?? MISSING_VALUE,
    activityIds,
  };

  return activityType;
}

export { toActivityType };
